import { AnimatePresence, motion } from 'framer-motion';

import { ReferenceType } from '../../../../../backend/src/types/types';
import { DrawerResizeHandle, useDrawerResize } from '@/new/components/drawers/drawer-resize';
import { ChunkDocumentDrawerContent } from '@/new/components/reference-content/chunk-document-drawer-content';
import { DocumentDrawerContent } from '@/new/components/reference-content/document-drawer-content';
import { FactDocumentDrawerContent } from '@/new/components/reference-content/fact-document-drawer-content';
import { ThreadFileChunkDrawerContent } from '@/new/components/reference-content/thread-file-chunk-drawer-content';

interface ReferenceLeftDrawerProps {
  isOpen: boolean;
  activeReferenceId: string | null;
  activeReferenceType: ReferenceType | null;
  onClose: () => void;
}

export function ReferenceLeftDrawer({
  isOpen,
  activeReferenceId,
  activeReferenceType,
  onClose,
}: ReferenceLeftDrawerProps) {
  const { width, isResizing, handleMouseDown } = useDrawerResize('left');

  return (
    <AnimatePresence>
      {isOpen && activeReferenceId && activeReferenceType && (
        <>
          <motion.div
            key="overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.15 }}
            onClick={onClose}
            className="fixed inset-0 z-50 bg-black/20"
          />
          <motion.div
            key="drawer"
            initial={{ x: '-100%' }}
            animate={{ x: 0 }}
            exit={{ x: '-100%' }}
            transition={{ type: 'tween', duration: 0.2 }}
            style={{ width: `${width}px` }}
            className={`fixed inset-y-0 left-0 z-50 flex h-full flex-col border-r ${isResizing ? 'border-teal-400' : 'border-gray-200'} bg-white shadow-xl transition-colors duration-300`}
          >
            <DrawerResizeHandle side="left" isResizing={isResizing} onMouseDown={handleMouseDown} />

            <div className="flex-1 overflow-hidden">
              {activeReferenceType === ReferenceType.Fact && <FactDocumentDrawerContent factId={activeReferenceId} />}
              {activeReferenceType === ReferenceType.Chunk && (
                <ChunkDocumentDrawerContent chunkId={activeReferenceId} />
              )}
              {activeReferenceType === ReferenceType.Document && <DocumentDrawerContent docId={activeReferenceId} />}
              {activeReferenceType === ReferenceType.ThreadFileChunk && (
                <ThreadFileChunkDrawerContent chunkId={activeReferenceId} />
              )}
              {activeReferenceType === ReferenceType.ThreadFile && (
                <ThreadFileChunkDrawerContent fileId={activeReferenceId} />
              )}
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
